var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29054 15.5418C1.94887 15.5418 1.66554 15.2585 1.66554 14.9168V10.1668C1.62387 7.9085 2.46554 5.77516 4.03221 4.17516C5.59887 2.5835 7.69887 1.7085 9.9572 1.7085C14.5739 1.7085 18.3322 5.46683 18.3322 10.0835V14.8335C18.3322 15.1752 18.0489 15.4585 17.7072 15.4585C17.3655 15.4585 17.0822 15.1752 17.0822 14.8335V10.0835C17.0822 6.1585 13.8905 2.9585 9.9572 2.9585C8.03221 2.9585 6.24887 3.70016 4.92387 5.05016C3.59054 6.4085 2.88221 8.21683 2.91554 10.1502V14.9085C2.91554 15.2585 2.64054 15.5418 2.29054 15.5418Z",
    fill: "#110428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9513 10.375H4.84297C3.09297 10.375 1.66797 11.8 1.66797 13.55V15.1167C1.66797 16.8667 3.09297 18.2917 4.84297 18.2917H4.9513C6.7013 18.2917 8.1263 16.8667 8.1263 15.1167V13.55C8.1263 11.8 6.7013 10.375 4.9513 10.375Z",
    fill: "#110428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1583 10.375H15.05C13.3 10.375 11.875 11.8 11.875 13.55V15.1167C11.875 16.8667 13.3 18.2917 15.05 18.2917H15.1583C16.9083 18.2917 18.3333 16.8667 18.3333 15.1167V13.55C18.3333 11.8 16.9083 10.375 15.1583 10.375Z",
    fill: "#110428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.8080b372fe756ca9cd51e10aa254c1ec.svg";
export { ForwardRef as ReactComponent };